import { useReduxState } from 'hooks';
import { Tooltip } from 'components/common';
import { Icon } from 'components/common/icons';

import type { IconProp } from 'components/common/icons/Icon';

interface Props {
  items: {
    icon?: IconProp;
    iconWithPlus?: boolean;
    label: React.ReactNode;
    labelTooltip?: string;
    value: React.ReactNode;
  }[];
}

const StatList = ({ items }: Props) => {
  const { theme } = useReduxState();

  if (!items) return null;

  return (
    <div className="stat-list">
      {items.map((item) => (
        <div className="item" key={item.label.toString()}>
          {item.icon ? (
            <div className="item-icon">
              <div className={item.iconWithPlus ? 'item-icon-with-plus' : ''}>
                <Icon fixedWidth={true} icon={item.icon} />
              </div>
              {item.iconWithPlus ? (
                <div className="item-icon-plus">
                  <Icon icon="plus" />
                </div>
              ) : null}
            </div>
          ) : null}

          <div className="item-label">
            <Tooltip childrenWrapInDiv={false} content={item.labelTooltip}>
              <div className="item-label-inner">
                {item.label}

                {item.labelTooltip ? (
                  <div className="item-label-icon">
                    <Icon icon="question-circle" />
                  </div>
                ) : null}
              </div>
            </Tooltip>
          </div>

          <div className="item-value">{item.value}</div>
        </div>
      ))}

      <style jsx>{`
        .item {
          align-items: center;
          display: flex;
          font-size: 1.5rem;
          gap: 10px;
          padding: 12px 20px;
        }
        .item:not(:first-child) {
          border-top: 1px solid ${theme.lightGrey};
        }
        .item-icon {
          color: ${theme.textColorLighter};
          flex-grow: 0;
          flex-shrink: 0;
          font-size: 1.3rem;
          line-height: 1;
          position: relative;
        }
        .item-icon-with-plus {
          position: relative;
          right: 2px;
        }
        .item-icon-plus {
          background-color: ${theme.textColorLighter};
          border: 2px solid white;
          border-radius: 50px;
          color: white;
          font-size: 0.6rem;
          padding: 1px;
          position: absolute;
          bottom: -5px;
          right: -3px;
        }
        .item-label {
          color: ${theme.textColorLighter};
          flex-grow: 1;
          flex-shrink: 1;
          font-size: 1.5rem;
          font-weight: 600;
        }
        .item-label-inner {
          display: inline-flex;
          gap: 5px;
        }
        .item-label-icon {
          font-size: 1.3rem;
          position: relative;
          top: 2px;
        }
        .item-value {
          color: ${theme.textColor};
          flex-grow: 0;
          flex-shrink: 0;
          font-size: 1.6rem;
          font-weight: 700;
        }
      `}</style>
    </div>
  );
};

export default StatList;
